import React from 'react'
import Typography from '@mui/material/Typography'
import EasyManage from '../../Assets/images/PNG/Form_Ai/EasyManage.png'
import { Box, Grid, Container, Button } from '@mui/material'
import './FormAi.css'


const Third = () => {
  return (
    <Box className="ThirdMain">
      <Container >
        <Grid container spacing={6} >
          <Grid item xs={12} md={6} sm={6}>
            <Box className="Third_text">
              <Typography variant="h4" color="initial" fontWeight={600}>Easy for you to manage</Typography>
              <Typography variant="body1" color='secondary' sx={{ marginTop: '17px' }}>SStreamline your insurance proposal process with our easy-to-use, intuitive and professional dashboard, featuring real-time notifications, algorithm-generated scores, and form archiving capabilities.</Typography>
              <Button variant="contained" color="secondary" sx={{ bgcolor: 'background.custom', marginTop: '40px', borderRadius: '10px' }}>
                Try For Free
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}  md={6} style={{overflow:'hidden'}}>
            <img src={EasyManage} alt="" className='Third_Img' style={{marginLeft:"auto"}} />
          </Grid>
        </Grid> 
      </Container>
    </Box>
  )
}

export default Third